import { render, staticRenderFns } from "./VoucherChangeHistory.vue?vue&type=template&id=228f8541"
import script from "./VoucherChangeHistory.vue?vue&type=script&lang=js"
export * from "./VoucherChangeHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports